/* Delegate to the original Flow cart-quantity remove control, including after AJAX re-renders. */
document.addEventListener('click', function(event) {
  var visible = event.target.closest('[data-buioch-cart-title-remove]');
  if (!visible) return;
  var card = visible.closest('.cart-drawer__product_card');
  if (!card) return;
  var original = card.querySelector('cart-quantity [data-cart-remove-item]');
  if (!original || visible.disabled) return;
  event.preventDefault();
  visible.disabled = true;
  original.click();
  window.setTimeout(function(){ if(visible.isConnected) visible.disabled = false; }, 1200);
});
